import { ArrowRight, ShieldCheck, Leaf } from "lucide-react";

export default function Hero() {
  return (
    <section id="top" className="relative pt-32 pb-20 lg:pt-44 lg:pb-28 overflow-hidden">
      {/* Backdrop image with overlay */}
      <div className="absolute inset-0 -z-10">
        <img
          src="https://images.unsplash.com/photo-1581578731548-c64695cc6952?auto=format&fit=crop&w=2400&q=80"
          alt="Bureaux modernes nettoyés"
          className="w-full h-full object-cover opacity-25"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background via-background/85 to-background" />
        <div className="absolute inset-0 bg-grain opacity-[0.04]" />
      </div>

      <div className="px-6 sm:px-10 lg:px-16 xl:px-24 grid lg:grid-cols-12 gap-12 items-end">
        <div className="lg:col-span-8 animate-fade-up">
          <div className="eyebrow mb-8" data-testid="hero-eyebrow">Nettoyage professionnel · Belgique</div>
          <h1
            data-testid="hero-title"
            className="text-5xl sm:text-6xl lg:text-7xl xl:text-[88px] leading-[0.95] font-light"
          >
            La propreté <span className="italic font-normal text-[hsl(var(--accent))]">irréprochable</span>,
            <br />
            la confiance <span className="shine-text">durable</span>.
          </h1>
          <p className="mt-10 max-w-2xl text-base lg:text-lg text-muted-foreground leading-relaxed">
            Akay accompagne entreprises, syndics et entrepreneurs en Belgique pour un entretien de bureaux
            méticuleux et un nettoyage de fin de chantier impeccable. Une équipe formée, assurée, équipée — au
            service de votre image.
          </p>

          <div className="mt-12 flex flex-wrap items-center gap-4" data-testid="hero-ctas">
            <a href="#devis" className="btn-primary" data-testid="hero-cta-devis">
              Obtenir un devis gratuit <ArrowRight className="w-4 h-4" />
            </a>
            <a href="#services" className="btn-outline" data-testid="hero-cta-services">
              Découvrir nos services
            </a>
          </div>
        </div>

        <div className="lg:col-span-4 grid grid-cols-1 gap-3">
          {[
            { icon: ShieldCheck, label: "Assurés & certifiés", desc: "Personnel formé, équipement professionnel" },
            { icon: Leaf, label: "Éco-responsables", desc: "Produits écolabel, microfibres réutilisables" },
          ].map((it, idx) => (
            <div
              key={idx}
              className="group p-5 border border-border rounded-sm bg-card/50 backdrop-blur-sm hover:border-[hsl(var(--accent))] transition-all duration-500"
              data-testid={`hero-feature-${idx}`}
              style={{ animationDelay: `${idx * 120}ms` }}
            >
              <div className="flex items-start gap-4">
                <it.icon className="w-5 h-5 text-[hsl(var(--primary))] mt-0.5 shrink-0" />
                <div>
                  <div className="font-medium text-foreground">{it.label}</div>
                  <div className="text-sm text-muted-foreground mt-1">{it.desc}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
